import { ApiInstitution, ApiListInstitutionsResponse } from '@repo/types';
import { useApi } from './useApi';
import { useQueryKeys } from '@src/hooks/useQueryKeys';
import { useQuery } from 'react-query';
import { useEnabled } from './useEnabled';

export interface UseGetInstitutionsParams {
  types?: string[];
  status?: string;
  term?: string;
}

export function useGetInstitutions(params?: UseGetInstitutionsParams) {
  const api = useApi();
  const queryKey = useQueryKeys(['institutions', params || {}]);
  const enabled = useEnabled();

  const fetchInstitutions = async (): Promise<ApiInstitution[]> => {
    const queryParams = new URLSearchParams();

    if (params?.types && params.types.length > 0) {
      params.types.forEach((type) => {
        queryParams.append('types', type);
      });
    }

    if (params?.status) {
      queryParams.set('status', params.status);
    }

    if (params?.term) {
      queryParams.set('term', params.term);
    }

    const url = queryParams.toString()
      ? `/institutions?${queryParams.toString()}`
      : '/institutions';

    const response = await api.get(url);
    const institutionsResponse =
      (await response?.json()) as ApiListInstitutionsResponse;
    return institutionsResponse.institutions;
  };

  return useQuery(queryKey, fetchInstitutions, { enabled });
}
